<div class="basin-width-100 basin-pb-4">
  <form [formGroup]="form">
    <div class="basin-width-100 {{this.maxLengthExceeded ? 'max-length-exceeded' : ''}}">
      <formly-form [form]="form" [fields]="fields" [model]="model">
      </formly-form>
      <small
        class="basin-width-100 {{(model?.content?.length ?? 0) > contentMaxLength ? 'p-error ng-star-inserted' : 'character-counter'}}">
        {{model?.content?.length}}/150 characters
      </small>
    </div>
    <div class="basin-pb-1 basin-pt-4 basin-width-100" *ngIf="config.data.status === StudyAreaStatus.Paid">
      <div class="basin-display-flex basin-align-items-center">
        <h6>Paid Status Billing Information</h6>
      </div>
      <div class="basin-pb-2 basin-pt-4 basin-width-100">
        <formly-form [form]="form" [fields]="billingFields" [model]="model">
        </formly-form>
      </div>
    </div>
  </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton (mousedown)="cancel()" label="Cancel" class="p-button-text basin-mr-6"></button>
  <button pButton type="submit" (click)="accept(model)" class="p-button-text" [disabled]="isSaveDisabled(model)"
    label="Save"></button>
</div>